import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  Button,
  StyleSheet,
  Alert,
  Linking,
  Platform,
} from 'react-native';


import { generateCodeChallenge, generateCodeVerifier } from '../../../utils/TNE/OIDC';

import { sha256 } from 'js-sha256';
//https://lili-c7853.firebaseapp.com/__/auth/handler

const ark = encodeURIComponent("ark:/19153/rcbq94w2b");
const authorization_endpoint = `https://idp-auth.partenaire.test-gar.education.fr/oidc/oidcAuthorize?idRessouce=${encodeURIComponent(ark)}`;
let userinfo_endpoint = `https://app-tne-pp.lili.cool/cas_proxy/oidc/oidcProfile?idRessource=${encodeURIComponent(ark)}`;
if (Platform.OS !== "web") {
  userinfo_endpoint = `${userinfo_endpoint}&access_mode=appnat`;
}

const CLIENT_ID = Platform.OS === "web" ? "9885f093-2bf9-46be-b8d0-cf57acbcb988" : "786f5083-4ca1-77fa-c0e4-df27befad713";
const REDIRECT_URI = Platform.OS === "web" ? "https://app-tne-pp.lili.cool/openid/" : "coolliliapp://oauthredirect/openid/";
const AUTHORIZATION_ENDPOINT = authorization_endpoint;
const TOKEN_ENDPOINT = 'https://app-tne-pp.lili.cool/cas_proxy/oidc/oidcAccessToken';
const LOGOUT_ENDPOINT = 'https://app-tne-pp.lili.cool/cas_proxy/oidc/oidcLogout';
const USERINFO_ENDPOINT = userinfo_endpoint;
const CLIENT_SECRET = "g0NMSqrR6kjjDcbY8lf0mchODApJcQGUUNy03uLGn6Tf8Dhvz4q3BauzeDU/XijZD57dkMLSuiBnCAGTNk8xGA==";

// https://idp-auth.partenaire.test-gar.education.fr/oidc/authorize?redirect_uri=coolliliapp%3A%2F%2Foauthredirect%2Fopenid%2F&client_id=786f5083-4ca1-77fa-c0e4-df27befad713&response_type=code&state=sRLw6bKI9qB7-zfG924t_bJW1ndUjMzj&nonce=7k-v9RK0184OG6m7OthM-6gR._QkEpsF&scope=openid%20scope.gar&code_challenge=Sbd7Qdb7D01H5kvmIJ8lwxTQbTpcY73Yl0Pig4VpXPs&code_challenge_method=S256&idRessource=ark%3A%2F19153%2Frcbq94w2b&access_mode=appnat&idEtab=0013358W&profil=National_ens

let idEtab: string | null = null;
let profil: string | null = null;
//idEtab = "0013358W";
//profil = "National_ens";

type AUTH_TOKEN = {
  "access_token": string;
  "token_type": string;
  "refresh_token": string;
  "expires_in": number;
  "id_token": string;
}

type AUTH_USER_INFO = {
  "IDO": string;
  "NOM": string;
  "PRE": string;
  "PRO": string;
  "P_MEL": string;
  "P_MS2": string;
  "UAI": string;
  "auth_time": number;
  "client_id": string;
  "id": string;
  "service": string;
  "sub": string;
}

export const startAuth = async (idEtablissement?: string, userProfile?: string) => {
  try {

    const codeVerifier = generateCodeVerifier();
    const codeChallenge = generateCodeChallenge(codeVerifier);
    const state = generateCodeVerifier(32);
    const nonce = generateCodeVerifier(32);

    sessionStorage.setItem("code_verifier", codeVerifier);
    sessionStorage.setItem("code_challenge", codeChallenge);
    sessionStorage.setItem("state", state);
    sessionStorage.setItem("nonce", nonce);

    const host: string = "https://idp-auth.partenaire.test-gar.education.fr";
    //let authUrl: string = host + "/oidc/oidcAuthorize?idRessource=" + encodeURIComponent(ark);
    let authUrl: string = `${host}/oidc/oidcAuthorize?redirect_uri=${encodeURIComponent(REDIRECT_URI)}&client_id=${encodeURIComponent(CLIENT_ID)}&response_type=code&state=${encodeURIComponent(state)}&nonce=${encodeURIComponent(sha256(nonce))}&scope=openid%20scope.gar&code_challenge=${encodeURIComponent(codeChallenge)}&code_challenge_method=S256&idRessource=${ark}`;
    //let authUrl: string = `${host}/oidc/oidcAuthorize?redirect_uri=${REDIRECT_URI}&client_id=${CLIENT_ID}&response_type=code&state=${state}&nonce=${sha256(nonce)}&scope=openid%20scope.gar&code_challenge=${codeChallenge}&code_challenge_method=S256&idRessource=${ark}`;
    if (Platform.OS !== "web") {
      authUrl = `${authUrl}&access_mode=appnat`;
    }
    if ((idEtablissement !== undefined) && (idEtablissement !== null)) {
      authUrl = `${authUrl}&idEtab=${idEtablissement}`;
    }
    if ((userProfile !== null) && (userProfile !== undefined)) {
      authUrl = `${authUrl}&profil=${userProfile}`;
    }
    console.log({ authUrl });
    window.location.href = authUrl;
    //Linking.openURL(authUrl);
  } catch (error) {
    console.error('❌ Erreur login OIDC :', error);
  }
}

export const fetchUserInfo = async (authToken) => {
  if (authToken !== null) {
    try {
      const userInfoResponse = await fetch(USERINFO_ENDPOINT, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken.access_token}`
        }
      })
      console.log({ userInfoResponse });
      const userInfo = await userInfoResponse.json();
      console.log({ userInfo });
    } catch (error) {

    }
  }
}

export const fetchOIDCAuthToken = async () => {
  try {
    const sessionCode: string = sessionStorage.getItem("code");
    const sessionCodeVerifier: string = sessionStorage.getItem("code_verifier");
    if ((sessionCode !== null) && (sessionCodeVerifier !== null)) {
      // Echanger le code contre les tokens
      const body = {
        "redirect_uri": encodeURIComponent(REDIRECT_URI),
        "code": sessionCode,
        "code_verifier": sessionCodeVerifier
      }
      const bodyAsString = `code=${sessionCode}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&grant_type=authorization_code&code_verifier=${sessionCodeVerifier}`;
      const tokenResponse = await fetch(TOKEN_ENDPOINT, {
        method: 'OPTIONS',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          "Authorization": `Basic ${CLIENT_ID}:${CLIENT_SECRET}`
        },
        body: bodyAsString
      });
      console.log({ tokenResponse });
      const tokenJson = await tokenResponse.json();
      console.log('✅ Access Token :', tokenJson);
      await fetchUserInfo(tokenJson);
    }
  } catch (error) {
    console.log({ error });
  }
}

const LoginScreen = () => {
  const [authCodes, setAuthCodes] = useState<{ code_verifier: string; code: string, nonce?: string } | null>(null);
  const [authToken, setAuthToken] = useState<AUTH_TOKEN | null>(null);
  const [authUserInfo, setAuthUserInfo] = useState<AUTH_USER_INFO | null>(null);

  useEffect(() => {
    if (authCodes !== null) {
      fetchAuthToken();
    } else {
      console.log("WHAT ?");
      setAuthToken(null);
    }
  }, [authCodes]);

  useEffect(() => {
    if (authToken !== null) {
      fetchUserInfo();
    } else {
      console.log("WHIT ?");
      setAuthUserInfo(null);
    }
  }, [authToken]);

  useEffect(() => {
    if (authUserInfo !== null) {
      idEtab = authUserInfo.UAI;
      profil = authUserInfo.PRO;
      loginWithFirebase();
    }
  }, [authUserInfo]);

  const loginWithFirebase = async () => {
    // On lance la connexion avec Firebase
    /*
    try {
      const credential = OIDCAuthProvider.credential(
        'gar-app-native', // this is the "Provider ID" value from the firebase console
        authToken?.id_token,
        authCodes?.nonce
      );

      const signInResponse: FirebaseAuthTypes.UserCredential = await signInWithCredential(getAuth(), credential);
      console.log({ signInResponse });
      // On va ensuite voir si on a un utilisateur avec les infos
      const getuser = await getFirestore().collection("users").where("IDO", "==", authUserInfo?.IDO).get();
      if (getuser.empty === true) {
        // On créer un utilisateur
        getFirestore().collection("users").doc(signInResponse.user.uid).set(authUserInfo);
      } else {
        // On copie l'utilisateur avec le nouvel id
        const userInfo = getuser.docs[0];
        const userId = userInfo.id;
        const userData = userInfo.data();
        await getFirestore().collection("users").doc(signInResponse.user.uid).set(userData);
        console.log("done > ", signInResponse.user.uid)
       await  getFirestore().collection("users").doc(userId).delete();
        console.log("delete > ", userId)
      }
    } catch (error) {
      console.log({ error });
    }
  */
  }

  const fetchAuthToken = async () => {
    try {
      const sessionCode: string = sessionStorage.getItem("code");
      const sessionCodeVerifier: string = sessionStorage.getItem("code_verifier");
      if ((sessionCode !== null) && (sessionCodeVerifier !== null)) {
        // Echanger le code contre les tokens
        const tokenResponse = await fetch(TOKEN_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `grant_type=authorization_code&` +
            `client_id=${encodeURIComponent(CLIENT_ID)}&` +
            `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
            `code=${encodeURIComponent(sessionCode)}&` +
            `code_verifier=${encodeURIComponent(sessionCodeVerifier)}`
        });
        console.log({ tokenResponse });
        const tokenJson = await tokenResponse.json();
        console.log('✅ Access Token :', tokenJson.access_token);
        console.log('✅ ID Token :', tokenJson.id_token);
        setAuthToken(tokenJson);
      }
    } catch (error) {

    }
  }

  const fetchUserInfo = async () => {
    if (authToken !== null) {
      try {
        const userInfoResponse = await fetch(USERINFO_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken.access_token}`
          }
        })
        console.log({ userInfoResponse });
        const userInfo = await userInfoResponse.json();
        console.log({ userInfo });
        setAuthUserInfo(userInfo);
      } catch (error) {

      }
    }
  }

  const logOut = async () => {
    try {
      const userLogoutUrl: string = `${LOGOUT_ENDPOINT}?id_token_hint=${authToken?.id_token}`;
      const userLogoutResponse = await fetch(userLogoutUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken.access_token}`
        }
      })
      console.log({ userLogoutResponse });
      signOut(getAuth());
      setAuthCodes(null);
    } catch (error) {

    }
  }

  const renderAuthButton = () => {
    return <View />
    if (authUserInfo === null) {
      if ((idEtab !== null) && (profil !== null)) {
        return <View>
          <Button title={`Se connecter à l'établissement ${idEtab} en tant que ${profil}`} onPress={() => startAuth(idEtab, profil)} />
          <Button title={`Se connecter à une autre établissement et / ou un autre profil`} onPress={() => startAuth()} />
        </View>
      }
      return <Button title="Se connecter" onPress={() => startAuth()} />
    }
    return <Button title="Se deconnecter" onPress={logOut} />
  }

  const renderUserInfo = () => {
    if (authUserInfo === null) {
      return <View />
    }
    return <View>
      <Text style={styles.title}>{`🥳 Utilisateur connecté 🥳`}</Text>
      <Text style={styles.label}>{`Prenom : ${authUserInfo.PRE}`}</Text>
      <Text style={styles.label}>{`Nom : ${authUserInfo.NOM}`}</Text>
      <Text style={styles.label}>{`Email : ${authUserInfo.P_MEL}`}</Text>
      <Text style={styles.label}>{`UAI : ${authUserInfo.UAI}`}</Text>
      <Text style={styles.label}>{`Type d'utilisateur : ${authUserInfo.PRO}`}</Text>
    </View>
  }
  return <View />
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Connexion GAR (OIDC manuelle)</Text>
      {renderAuthButton()}
      {renderUserInfo()}
    </View>
  );
};

export default LoginScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  title: {
    color: "#404040",
    fontSize: 20,
    marginBottom: 30,
  },
  label: {
    color: "#606060",
    fontSize: 16
  },
  token: {
    marginTop: 20,
    color: 'green',
    fontSize: 12,
  },
});